import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { MONTH_ITEM_HEIGHT as S } from "../config.js";
import { datePickerInjectionKey as ge } from "../interface.js";
import { dateArray as je, monthArray as Fe, yearArray as Me, quarterArray as Se, strictParse as Y, getDefaultTime as Ye } from "../utils.js";
import { usePanelCommonProps as qe, usePanelCommon as Pe } from "./use-panel-common.js";
import { set as k } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/set.js";
import { setQuarter as Ue } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/setQuarter.js";
import { setMonth as _e } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/setMonth.js";
import { startOfSecond as He } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfSecond.js";
import { startOfQuarter as xe } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfQuarter.js";
import { startOfWeek as We } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfWeek.js";
import { inject as Be, computed as o, watch as q } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as s } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { formatDate as v } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/format.js";
import { isSameMonth as Ee } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/isSameMonth.js";
import { isValid as P } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/isValid.js";
import { getTime as r } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/getTime.js";
import { getYear as D } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/getYear.js";
import { getMonth as b } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/getMonth.js";
import { getDate as U } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/getDate.js";
import { setYear as _ } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/setYear.js";
import { addYears as H } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/addYears.js";
import { addMonths as x } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/addMonths.js";
import { startOfMonth as Ne } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfMonth.js";
import { startOfYear as ze } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfYear.js";
import { startOfDay as Le } from "../../../../../../../date-fns@3.6.0/node_modules/date-fns/startOfDay.js";
const Da = Object.assign(Object.assign({}, qe), {
  defaultCalendarStartTime: Number,
  actions: {
    type: Array,
    default: () => ["now", "clear", "confirm"]
  }
});
function ba(a, i) {
  var R;
  const n = Pe(a), {
    isValueInvalidRef: W,
    isDateDisabledRef: B,
    isDateInvalidRef: E,
    isTimeInvalidRef: N,
    isDateTimeInvalidRef: z,
    isHourDisabledRef: L,
    isMinuteDisabledRef: Q,
    isSecondDisabledRef: G,
    localeRef: f,
    firstDayOfWeekRef: T,
    datePickerSlots: I,
    yearFormatRef: K,
    monthFormatRef: J,
    quarterFormatRef: X,
    yearRangeRef: V
  } = Be(ge), O = {
    isValueInvalid: W,
    isDateDisabled: B,
    isDateInvalid: E,
    isTimeInvalid: N,
    isDateTimeInvalid: z,
    isHourDisabled: L,
    isMinuteDisabled: Q,
    isSecondDisabled: G
  }, m = o(() => a.dateFormat || f.value.dateFormat), Z = o(() => a.calendarDayFormat || f.value.dayFormat), d = s(a.value === null || Array.isArray(a.value) ? "" : v(a.value, m.value)), u = s(a.value === null || Array.isArray(a.value) ? (R = a.defaultCalendarStartTime) !== null && R !== void 0 ? R : Date.now() : a.value), y = s(null), C = s(null), w = s(null), A = s(Date.now()), g = o(() => {
    var e;
    return je(u.value, a.value, A.value, (e = T.value) !== null && e !== void 0 ? e : f.value.firstDayOfWeek, !1, i === "week");
  }), $ = o(() => {
    const {
      value: e
    } = a;
    return Fe(u.value, Array.isArray(e) ? null : e, A.value, {
      monthFormat: J.value
    });
  }), p = o(() => {
    const {
      value: e
    } = a;
    return Me(Array.isArray(e) ? null : e, A.value, {
      yearFormat: K.value
    }, V);
  }), ee = o(() => {
    const {
      value: e
    } = a;
    return Se(u.value, Array.isArray(e) ? null : e, A.value, {
      quarterFormat: X.value
    });
  }), ae = o(() => g.value.slice(0, 7).map((e) => {
    const {
      ts: t
    } = e;
    return v(t, Z.value, n.dateFnsOptions.value);
  })), te = o(() => v(u.value, a.calendarHeaderMonthFormat || f.value.monthFormat, n.dateFnsOptions.value)), ne = o(() => v(u.value, a.calendarHeaderYearFormat || f.value.yearFormat, n.dateFnsOptions.value)), re = o(() => {
    var e;
    return (e = a.calendarHeaderMonthBeforeYear) !== null && e !== void 0 ? e : f.value.monthBeforeYear;
  });
  q(u, (e, t) => {
    (i === "date" || i === "datetime") && (Ee(e, t) || n.disableTransitionOneTick());
  }), q(o(() => a.value), (e) => {
    e !== null && !Array.isArray(e) ? (d.value = v(e, m.value, n.dateFnsOptions.value), u.value = e) : d.value = "";
  });
  function c(e) {
    var t;
    if (i === "datetime")
      return r(He(e));
    if (i === "month")
      return r(Ne(e));
    if (i === "year")
      return r(ze(e));
    if (i === "quarter")
      return r(xe(e));
    if (i === "week") {
      const l = (((t = T.value) !== null && t !== void 0 ? t : f.value.firstDayOfWeek) + 1) % 7;
      return r(We(e, {
        weekStartsOn: l
      }));
    }
    return r(Le(e));
  }
  function j(e, t) {
    const {
      isDateDisabled: {
        value: l
      }
    } = O;
    return l ? l(e, t) : !1;
  }
  function le(e) {
    const t = Y(e, m.value, /* @__PURE__ */ new Date(), n.dateFnsOptions.value);
    if (P(t)) {
      if (a.value === null)
        n.doUpdateValue(r(c(Date.now())), a.panel);
      else if (!Array.isArray(a.value)) {
        const l = k(a.value, {
          year: D(t),
          month: b(t),
          date: U(t)
        });
        n.doUpdateValue(r(c(r(l))), a.panel);
      }
    } else
      d.value = e;
  }
  function ie() {
    const e = Y(d.value, m.value, /* @__PURE__ */ new Date(), n.dateFnsOptions.value);
    if (P(e)) {
      if (a.value === null)
        n.doUpdateValue(r(c(Date.now())), !1);
      else if (!Array.isArray(a.value)) {
        const t = k(a.value, {
          year: D(e),
          month: b(e),
          date: U(e)
        });
        n.doUpdateValue(r(c(r(t))), !1);
      }
    } else
      me();
  }
  function ue() {
    n.doUpdateValue(null, !0), d.value = "", n.doClose(!0), n.handleClearClick();
  }
  function oe() {
    n.doUpdateValue(r(c(Date.now())), !0);
    const e = Date.now();
    u.value = e, n.doClose(!0), a.panel && (i === "month" || i === "quarter" || i === "year") && (n.disableTransitionOneTick(), h(e));
  }
  const F = s(null);
  function de(e) {
    e.type === "date" && i === "week" && (F.value = c(r(e.ts)));
  }
  function ce(e) {
    return e.type === "date" && i === "week" ? c(r(e.ts)) === F.value : !1;
  }
  function fe(e) {
    if (j(e.ts, e.type === "date" ? {
      type: "date",
      year: e.dateObject.year,
      month: e.dateObject.month,
      date: e.dateObject.date
    } : e.type === "month" ? {
      type: "month",
      year: e.dateObject.year,
      month: e.dateObject.month
    } : e.type === "year" ? {
      type: "year",
      year: e.dateObject.year
    } : {
      type: "quarter",
      year: e.dateObject.year,
      quarter: e.dateObject.quarter
    }))
      return;
    let t;
    if (a.value !== null && !Array.isArray(a.value) ? t = a.value : t = Date.now(), i === "datetime" && a.defaultTime !== null && !Array.isArray(a.defaultTime)) {
      const l = Ye(a.defaultTime);
      l && (t = r(k(t, l)));
    }
    switch (t = r(e.type === "quarter" && e.dateObject.quarter ? Ue(_(t, e.dateObject.year), e.dateObject.quarter) : k(t, e.dateObject)), n.doUpdateValue(c(t), a.panel || i === "date" || i === "week" || i === "year"), i) {
      case "date":
      case "week":
        n.doClose();
        break;
      case "year":
        a.panel && n.disableTransitionOneTick(), n.doClose();
        break;
      case "month":
        n.disableTransitionOneTick(), h(t);
        break;
      case "quarter":
        n.disableTransitionOneTick(), h(t);
        break;
    }
  }
  function se(e, t) {
    let l;
    a.value !== null && !Array.isArray(a.value) ? l = a.value : l = Date.now(), l = r(e.type === "month" ? _e(l, e.dateObject.month) : _(l, e.dateObject.year)), t(l), h(l);
  }
  function ve(e) {
    u.value = e;
  }
  function me(e) {
    if (a.value === null || Array.isArray(a.value)) {
      d.value = "";
      return;
    }
    e === void 0 && (e = a.value), d.value = v(e, m.value, n.dateFnsOptions.value);
  }
  function M() {
    O.isDateInvalid.value || O.isTimeInvalid.value || (n.doConfirm(), ye());
  }
  function ye() {
    a.active && n.doClose();
  }
  function he() {
    var e;
    u.value = r(H(u.value, 1)), (e = a.onNextYear) === null || e === void 0 || e.call(a);
  }
  function De() {
    var e;
    u.value = r(H(u.value, -1)), (e = a.onPrevYear) === null || e === void 0 || e.call(a);
  }
  function be() {
    var e;
    u.value = r(x(u.value, 1)), (e = a.onNextMonth) === null || e === void 0 || e.call(a);
  }
  function Oe() {
    var e;
    u.value = r(x(u.value, -1)), (e = a.onPrevMonth) === null || e === void 0 || e.call(a);
  }
  function Ae() {
    const {
      value: e
    } = y;
    return (e == null ? void 0 : e.listElRef) || null;
  }
  function ke() {
    const {
      value: e
    } = y;
    return (e == null ? void 0 : e.itemsElRef) || null;
  }
  function Re() {
    var e;
    (e = C.value) === null || e === void 0 || e.sync();
  }
  function we(e) {
    e !== null && n.doUpdateValue(e, a.panel);
  }
  function Te(e) {
    n.cachePendingValue();
    const t = n.getShortcutValue(e);
    typeof t == "number" && n.doUpdateValue(t, !1);
  }
  function Ve(e) {
    const t = n.getShortcutValue(e);
    typeof t == "number" && (n.doUpdateValue(t, a.panel), n.clearPendingValue(), M());
  }
  function h(e) {
    const {
      value: t
    } = a;
    if (w.value) {
      const l = e === void 0 ? t === null ? b(Date.now()) : b(t) : b(e);
      w.value.scrollTo({
        top: l * S
      });
    }
    if (y.value) {
      const l = (e === void 0 ? t === null ? D(Date.now()) : D(t) : D(e)) - V.value[0];
      y.value.scrollTo({
        top: l * S
      });
    }
  }
  const Ce = {
    monthScrollbarRef: w,
    yearScrollbarRef: C,
    yearVlRef: y
  };
  return Object.assign(Object.assign(Object.assign(Object.assign({
    dateArray: g,
    monthArray: $,
    yearArray: p,
    quarterArray: ee,
    calendarYear: ne,
    calendarMonth: te,
    weekdays: ae,
    calendarMonthBeforeYear: re,
    mergedIsDateDisabled: j,
    nextYear: he,
    prevYear: De,
    nextMonth: be,
    prevMonth: Oe,
    handleNowClick: oe,
    handleConfirmClick: M,
    handleSingleShortcutMouseenter: Te,
    handleSingleShortcutClick: Ve
  }, O), n), Ce), {
    // datetime only
    handleDateClick: fe,
    handleDateInputBlur: ie,
    handleDateInput: le,
    handleDateMouseEnter: de,
    isWeekHovered: ce,
    handleTimePickerChange: we,
    clearSelectedDateTime: ue,
    virtualListContainer: Ae,
    virtualListContent: ke,
    handleVirtualListScroll: Re,
    timePickerSize: n.timePickerSize,
    dateInputValue: d,
    datePickerSlots: I,
    handleQuickMonthClick: se,
    justifyColumnsScrollState: h,
    calendarValue: u,
    onUpdateCalendarValue: ve
  });
}
export {
  ba as useCalendar,
  Da as useCalendarProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/panel/use-calendar.js
// module id = 460
// module chunks = 41